// extracted by mini-css-extract-plugin
export default {"imagePlaceholder":"LoadableImage_imagePlaceholder__AcgZJ","image":"LoadableImage_image__TTjmn"};